/* Tiloa Duck — comportements partagés des sections tiloa-duck-*.
 *
 * Chargé uniquement sur le gabarit product.canard. Aucune requête réseau,
 * aucun second formulaire : les boutons d'achat de bas de page relaient le
 * clic vers le vrai bouton de la zone d'achat, comme la barre collante. La
 * quantité choisie dans les offres, le tiroir panier et la mesure restent
 * donc exactement ceux du bouton principal.
 *
 *   html.td-js                    posée tout de suite : les effets CSS n'existent qu'avec le script
 *   .td-reveal                    apparaît quand il entre à l'écran
 *   video[data-td-autoplay]       source chargée à l'approche (data-src), lecture muette en boucle
 *                                 tant qu'elle est visible ; jamais si « réduire les animations »
 *                                 (data-poster : image d'attente posée en poster à l'approche,
 *                                 et tout de suite si « réduire les animations »)
 *   [data-td-buy]                 relaie le clic vers le bouton d'achat principal
 *   [data-td-buy-label]           reçoit « Ajouter au panier — <total de l'offre choisie> »
 */
(function () {
  'use strict';
  document.documentElement.classList.add('td-js');

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sansEchec(fn) { try { fn(); } catch (e) { /* un effet raté ne doit rien casser d'autre */ } }

  /* ---------- Apparitions ---------- */
  function apparitions() {
    var els = document.querySelectorAll('.td-reveal');
    if (!els.length) return;
    if (reduit || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Vidéos ---------- */
  function charger(video) {
    /* Vitesse 25/10 (après relecture) : l'image d'attente fournie en data-poster (fiche
       chiffon, sections/tiloa-ch-videos.liquid) devient l'affiche de la vidéo à l'approche
       (observateur « approche », marge 600 px), au clic ou à la lecture : elle couvre le cadre
       avant son entrée à l'écran, comme l'ancien attribut poster. Même URL que l'image d'attente
       (img loading="lazy" placée dessous) : pas de second téléchargement. Après relecture : si la
       section est dans le seuil du chargement différé de Chrome, cette image part quand même au
       chargement initial, mais en priorité basse au lieu de moyenne. Sans data-poster (autres
       pages), cette ligne ne fait rien. */
    if (video.dataset.poster && !video.hasAttribute('poster')) video.poster = video.dataset.poster;
    if (video.dataset.tdLoaded) return;
    var mobile = video.getAttribute('data-src-mobile');
    var leger = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ||
      (navigator.connection && navigator.connection.saveData);
    var src = (leger && mobile) ? mobile : video.getAttribute('data-src');
    if (src) { video.src = src; }
    video.dataset.tdLoaded = '1';
  }

  function videos() {
    var list = document.querySelectorAll('video[data-td-autoplay]');
    if (!list.length) return;
    /* Vitesse 25/10 : toutes les lectures (position calculée de chaque parent) d'abord,
       puis toutes les écritures (style, bouton). Lire après l'ajout du bouton de la vidéo
       précédente forçait un recalcul du style à chaque vidéo. Même résultat : régler
       « relative » sur un parent déjà réglé ne change rien, et aucune règle CSS ne fait
       dépendre la position d'un parent du bouton ou des attributs de la vidéo. */
    var statique = [];
    if (!reduit) {
      list.forEach(function (v, i) {
        var parent = v.parentElement;
        statique[i] = !!parent && getComputedStyle(parent).position === 'static';
      });
    }
    list.forEach(function (v, i) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      if (reduit) {
        /* Pas de lecture automatique : le visiteur décide. */
        v.controls = true;
        v.preload = 'none';
        /* Vitesse 25/10 : image d'attente fournie en data-poster (fiche chiffon,
           sections/tiloa-ch-videos.liquid) pour ne pas la télécharger dès l'analyse du
           HTML. Ici, elle est posée tout de suite : avec ses commandes, la vidéo recouvre
           l'image placée dessous, elle doit donc afficher l'image elle-même. Hors de ce
           mode, charger() la pose à l'approche. */
        if (v.dataset.poster) v.poster = v.dataset.poster;
        return;
      }
      /* Une vidéo qui bouge plus de cinq secondes doit pouvoir être arrêtée
         (WCAG 2.2.2). Une fois mise en pause par le visiteur, elle ne repart
         plus d'elle-même. */
      var hote = v.parentElement;
      if (!hote) return;
      if (statique[i]) hote.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'td-vidctl';
      b.setAttribute('aria-label', 'Mettre la vidéo en pause');
      b.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><rect x="4" y="3" width="2.6" height="10" rx="1" fill="currentColor"/><rect x="9.4" y="3" width="2.6" height="10" rx="1" fill="currentColor"/></svg>';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (v.paused) {
          v.dataset.tdUserPaused = '';
          charger(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.dataset.tdUserPaused = '1';
          v.pause();
        }
      });
      var maj = function () {
        var enPause = v.paused;
        b.setAttribute('aria-label', enPause ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
        b.innerHTML = enPause
          ? '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M5 3.2v9.6c0 .5.5.8.9.5l7.2-4.8c.4-.2.4-.8 0-1l-7.2-4.8c-.4-.3-.9 0-.9.5z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><rect x="4" y="3" width="2.6" height="10" rx="1" fill="currentColor"/><rect x="9.4" y="3" width="2.6" height="10" rx="1" fill="currentColor"/></svg>';
      };
      v.addEventListener('play', maj);
      v.addEventListener('pause', maj);
      hote.appendChild(b);
    });
    if (!('IntersectionObserver' in window)) {
      list.forEach(function (v) { charger(v); if (!reduit) v.play().catch(function () {}); });
      return;
    }
    /* On charge un peu avant l'arrivée à l'écran, on ne lit qu'une fois
       la vidéo réellement visible, et on la met en pause en sortant. */
    var approche = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { charger(e.target); approche.unobserve(e.target); }
      });
    }, { rootMargin: '600px 0px' });
    var lecture = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (reduit) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.45) {
          if (v.dataset.tdUserPaused === '1') return;
          charger(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.45, 0.9] });
    list.forEach(function (v) { approche.observe(v); lecture.observe(v); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) list.forEach(function (v) { if (!v.paused) v.pause(); });
    });
  }

  /* ---------- Boutons d'achat relais ---------- */
  function boutonPrincipal() {
    var form =
      document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form[action*="/cart/add"]');
    return form && form.querySelector('[type="submit"][name="add"]');
  }

  function achats() {
    var relais = document.querySelectorAll('[data-td-buy]');
    if (!relais.length) return;
    var principal = boutonPrincipal();
    var total = null;

    function libelle() {
      return 'Ajouter au panier' + (total ? ' — ' + total : '');
    }

    function synchroniser() {
      if (!principal) principal = boutonPrincipal();
      var indispo = principal && (principal.disabled || principal.getAttribute('aria-disabled') === 'true');
      var enCours = principal && principal.classList.contains('is-adding');
      var ajoute = principal && principal.classList.contains('is-added');
      relais.forEach(function (b) {
        var cible = b.querySelector('[data-td-buy-label]') || b;
        b.disabled = !!indispo;
        b.classList.toggle('is-adding', !!enCours);
        b.classList.toggle('is-added', !!ajoute);
        if (indispo) cible.textContent = (principal.textContent || '').trim();
        else if (enCours) cible.textContent = 'Ajout…';
        else if (ajoute) cible.textContent = 'Ajouté ✓';
        else cible.textContent = libelle();
      });
    }

    relais.forEach(function (b) {
      b.addEventListener('click', function (ev) {
        if (!principal) principal = boutonPrincipal();
        if (!principal || principal.disabled) return;
        ev.preventDefault();
        principal.setAttribute('data-tiloa-relay', '1');
        try { principal.click(); } finally { principal.removeAttribute('data-tiloa-relay'); }
      });
    });

    document.addEventListener('tiloa:bundle-change', function (e) {
      if (e && e.detail && e.detail.totalFormatted) total = e.detail.totalFormatted;
      synchroniser();
    });

    if (principal && 'MutationObserver' in window) {
      new MutationObserver(synchroniser).observe(principal, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    }

    /* Valeur de départ : le total de l'offre déjà sélectionnée, lu dans la carte. */
    var carte = document.querySelector('[data-tiloa-bundle] .is-selected [data-bundle-total]');
    if (carte) total = carte.textContent.trim();
    synchroniser();
  }

  /* ---------- Prix du CTA final ----------
     Le bouton annonce le total de l'offre choisie ; le prix affiché juste
     au-dessus doit dire la même chose. En Duo ou Trio, on reprend tels quels
     les montants de la carte d'offre (total, prix de référence barré,
     économie) ; en Découverte, on revient au rendu Liquid d'origine. */
  function prixCta() {
    var bloc = document.querySelector('.td-cta__price');
    if (!bloc) return;
    var montant = bloc.querySelector('.td-cta__amount');
    var barre = bloc.querySelector('.td-cta__was s');
    var economie = bloc.querySelector('.td-cta__saving');
    var origine = {
      montant: montant ? montant.innerHTML : '',
      barre: barre ? barre.textContent : '',
      economie: economie ? economie.textContent : ''
    };
    var qte = document.createElement('span');
    qte.className = 'td-cta__qty';
    qte.hidden = true;
    bloc.appendChild(qte);

    document.addEventListener('tiloa:bundle-change', function (e) {
      var d = (e && e.detail) || {};
      var carte = d.quantity ? document.querySelector('[data-tiloa-bundle] [data-bundle-card][data-qty="' + d.quantity + '"]') : null;
      var was = bloc.querySelector('.td-cta__was');
      if (!carte || d.quantity <= 1) {
        if (montant) montant.innerHTML = origine.montant;
        if (barre) barre.textContent = origine.barre;
        if (was) was.hidden = false;
        if (economie) economie.textContent = origine.economie;
        qte.hidden = true;
        return;
      }
      var s = carte.querySelector('[data-bundle-saving]');
      var q = carte.querySelector('.tiloa-bundle__qty');
      if (montant && d.totalFormatted) montant.innerHTML = '<span class="visually-hidden">Prix de l\'offre </span>' + d.totalFormatted;
      var ref = carte.querySelector('[data-bundle-was-amount]');
      if (was && barre && ref) { barre.textContent = ref.textContent.trim(); was.hidden = false; }
      else if (was) was.hidden = true;
      if (economie && s) economie.textContent = s.textContent.trim();
      if (q) { qte.textContent = q.firstChild ? q.firstChild.textContent.trim() : q.textContent.trim(); qte.hidden = false; }
    });
  }

  /* ---------- Liens internes « Choisir mon … » (data-td-goto) ----------
     Défilement jusqu'à l'ancre, puis focus sur la couleur actuellement choisie :
     aucun changement de variante, aucun ajout au panier. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-td-goto][href^="#"]');
    if (!a) return;
    var cible = document.getElementById(a.getAttribute('href').slice(1));
    if (!cible) return;
    e.preventDefault();
    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
    var radio = document.querySelector('variant-selects input[type="radio"]:checked') || document.querySelector('variant-selects input, variant-selects select');
    if (radio && radio.focus) {
      try { radio.focus({ preventScroll: true }); } catch (err) { radio.focus(); }
    }
  });

  /* ---------- Clavier dans la bande d'avis (téléphone) ---------- */
  document.addEventListener('focusin', function (e) {
    var c = e.target && e.target.closest && e.target.closest('section#avis .reviews__grid > *');
    if (c && c.scrollIntoView) c.scrollIntoView({ block: 'nearest', inline: 'start' });
  });

  function demarrer() {
    sansEchec(apparitions);
    sansEchec(videos);
    sansEchec(achats);
    sansEchec(prixCta);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
